module.exports = require('./dist/input-slider.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-input-slider/index.js
// module id = 1923
// module chunks = 2